/**
 * The product starts a Central Dispatch OAuth reconnect here. That consent
 * belongs to the tenant's own account — the console cannot grant it on their
 * behalf — so the admin build surfaces the situation instead of a popup.
 */
export function startCdOAuthConnect(): Promise<never> {
  return Promise.reject(
    new Error('Central Dispatch needs to be reconnected by the organization’s own account.'),
  )
}
